import im13m from './im13-m'
import im16m from './im16-m'
import im18m from './im18-m'
import im21 from './im21'
import ib11 from './ib11'

export const imuProducts = {
  'im13-m': im13m,
  'im16-m': im16m,
  'im18-m': im18m,
  im21,
  ib11
}
